import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { GroupsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createGroup = (data): any => action(types.CREATE_GROUP_REQUESTED, data);

export const updateGroup = (data): any => action(types.UPDATE_GROUP_REQUESTED, data);

export const deleteGroup = (groupId): any => action(types.UPDATE_GROUP_REQUESTED, groupId);

export const getGroup = (groupId): any => action(types.GET_GROUP_REQUESTED, groupId);

export const getAllGroups = (
  organisationId: string = undefined,
  pagination: IPagination = undefined,
  compile = true,
  organisationIds = undefined,
): any => action(types.GET_ALL_GROUPS_REQUESTED, {
  organisationId,
  pagination,
  compile,
  organisationIds,
});

export const selectGroup = (groupId): any => action(types.SELECT_GROUP_REQUESTED, {
  currentGroupId: groupId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createGroupPending: (payload): any => action(types.CREATE_GROUP_PENDING, payload),
  createGroupSuccess: (response): any => {
    const currentGroup = response.entities.groups[response.result];
    // history.push(`/payment/${currentGroup.paymentCollection.id}/review`);
    return action(types.CREATE_GROUP_SUCCESS, {
      groupsById: response.entities.groups,
      currentGroupId: response.result,
    });
  },
  updateGroupPending: (payload): any => action(types.UPDATE_GROUP_PENDING, payload),
  updateGroupSuccess: (response): any => action(types.UPDATE_GROUP_SUCCESS, {
    groupsById: response.entities.groups,
    currentGroupId: response.result,
  }),
  updateGroupFailed: (error): any => action(types.UPDATE_GROUP_FAIL, { backendErrors: error }),
  deleteGroupPending: (): any => action(types.UPDATE_GROUP_PENDING, {}),
  deleteGroupSuccess: (response, userId): any => {
    localStorage.set(userId, { currentGroupId: null });
    history.push('/groups');

    return action(types.DELETE_GROUP_SUCCESS, {
      currentGroupId: response,
    });
  },
  getGroupPending: (): any => action(types.GET_GROUP_PENDING, {}),
  getGroupSuccess: (response): any => action(types.GET_GROUP_SUCCESS, {
    groupsById: response.entities.groups,
    currentGroupId: response.result,
  }),
  getGroupFailed: (error): any => action(types.GET_GROUP_FAIL, { backendErrors: error }),
  deleteGroupFailed: (error): any => action(types.UPDATE_GROUP_FAIL, { backendErrors: error }),
  getAllGroupsPending: (pagination): any => action(types.GET_ALL_GROUPS_PENDING, { pagination }),
  getAllGroupsSuccess: (response, meta): any => action(types.GET_ALL_GROUPS_SUCCESS, {
    groupsById: response.entities.groups,
    groupIds: response.result,
    meta,
  }),
  getAllGroupsFailed: (error): any => action(types.GET_ALL_GROUPS_FAIL, { backendErrors: error }),
  createGroupFailed: (error): any => action(types.CREATE_GROUP_FAIL, { backendErrors: error }),
};

export default {
  createGroup,
  updateGroup,
  deleteGroup,
  getGroup,
  getAllGroups,
  selectGroup,
};
